import {Translate} from 'react-redux-i18n';

import authenticationService from '../../services/authentication/AuthenticationService';

import DiscoverBdrBox from '../DiscoverBdrBox';
import ToggleBdrBoxButton from '../DiscoverBdrBox/ToggleBdrBoxButton';

import {useCustomStore} from './ProjectsStore';
import CreateProjectButton from './createProjectButton';
import Invitations from './invitations';
import List from './list';

function ProjectsView() {
  const {state: {totalCount}} = useCustomStore();
  const roles = authenticationService.roles();
  const isExplorer = roles.isExplorer();
  const isConsultant = roles.isConsultant();

  return (
    <>
      <div className="row mt-4 mb-5">
        <h1 className="col-md-6 m-0">
          <Translate value="project.myProjects"/>
          <span className="separator information">{totalCount}</span>
        </h1>
        <div className="col-md-6 d-md-flex justify-content-end">
          <ToggleBdrBoxButton/>
          <CreateProjectButton/>
        </div>
      </div>

      <DiscoverBdrBox/>

      {!isExplorer && !isConsultant && <Invitations/>}

      <List/>
    </>
  );
}

export default ProjectsView;
